import React, { useState } from 'react';
import { Shield, ChevronDown, ChevronUp, FileText, Users, BookOpen, Award, AlertCircle, Lock, Laptop, Scale, TrendingUp, Clock, Download } from 'lucide-react';

interface Section {
  id: string;
  title: string;
  icon: React.ReactNode;
  content: React.ReactNode;
}

const RegolamentoPage: React.FC = () => {
  const [expandedSections, setExpandedSections] = useState<string[]>(['1']);

  const toggleSection = (id: string) => {
    setExpandedSections(prev =>
      prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]
    );
  };

  const sections: Section[] = [
    {
      id: '1',
      title: '1. Requisiti di base e accesso alla Rete',
      icon: <FileText className="w-5 h-5" />,
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">1.1 Iscrizione all'UNASCA</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              Gli Studi di Consulenza Automobilistica che intendono entrare nella Rete Certificata, dovranno essere membri 
              attivi di UNASCA in regola con la quota associativa (o integrativa) STUDI per l'anno in corso.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">1.2 Conformità normativa</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li>Normative vigenti: Rispetto delle normative vigenti nel settore automobilistico.</li>
              <li>Codice Etico di UNASCA: Conformità al codice etico di UNASCA.</li>
              <li>Licenze e autorizzazioni: Possesso delle licenze e autorizzazioni richieste per operare.</li>
              <li>GDPR per la Privacy: Conformità al GDPR per la protezione dei dati personali.</li>
              <li>Cybersecurity: Adozione di misure di sicurezza informatica per proteggere i dati e le infrastrutture IT.</li>
              <li>Assicurazione professionale: Ogni agenzia deve possedere un'assicurazione professionale per coprire
eventuali danni o responsabilità derivanti dall'esercizio della propria attività. Sono esenti da questo requisito
i consorziati Sermetra.</li>
              <li>EBAS: Lo SdC che aderisce alla Rete Certificata dovrà dimostrare che versa al fondo EBAS i diritti stabiliti per
legge per gli eventuali dipendenti.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">1.3 Esperienza nel settore</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm"> 
              <li>Anzianità e servizi: Le agenzie devono essere attive da almeno un anno e presentare una lista dettagliata dei
servizi offerti.</li>
              <li>Collaborazioni e partenariati: La partecipazione a progetti collaborativi e partenariati con altre agenzie o enti
nel settore delle pratiche automobilistiche evidenzia l'attitudine all'innovazione e alla crescita continua.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">1.4 Impegno nella formazione continua</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm"> 
              <li>Frequenza obbligatoria: La certificazione nella rete UNASCA richiede la partecipazione attiva alla formazione
organizzata dal Centro Studi "Cesare Ferrari". Le figure che possono partecipare alla formazione e portare il
requisito della certificazione all'impresa includono il Titolare/Amministratore dello Studio di Consulenza
Automobilistica, i soggetti in possesso dell'attestato di capacità professionale 264/91 e i dipendenti che
abbiano almeno il terzo livello del CCNL "Autoscuole e Studi di Consulenza Automobilistica" o altri contratti
equivalenti che saranno valutati in fase di iscrizione al corso.</li>
<li>Varietà dei corsi: Selezione di corsi pertinenti alle necessità e specializzazioni dello SdC.</li>
<li>Aggiornamento continuo: Partecipazione a sessioni di aggiornamento periodiche per garantire che le
competenze rimangano allineate con le ultime tendenze e requisiti del settore.</li>
<li>Certificazioni: Al completamento di ogni corso, gli SdC ricevono certificazioni che attestano le competenze
acquisite. Queste certificazioni sono essenziali per dimostrare l'impegno dello SdC verso l'eccellenza e per
mantenere il proprio status all'interno della rete certificata..</li>
<li>Supporto e mentorship: Accesso a consulenze personalizzate e tutoraggio da parte di esperti del settore
individuati dal Centro Studi "Cesare Ferrari", favorendo così uno sviluppo professionale continuo.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">1.5 Iscrizione al Registro delle Agenzie Telematiche</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              Le Agenzie che intendono iscriversi alla Rete certificata, all'entrata in vigore del "Registro delle Agenzie
Telematiche" (ReAT) istituito presso il Ministero dei Trasporti, dovranno essere regolarmente iscritte a tale
Registro.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">1.6 Richiesta di adesione</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              La domanda di ammissione alla Rete Certificata UNASCA deve essere compilata in conformità con quanto
indicato nell'Allegato 1.<br/>
<br/>
La domanda, completa di tutti i documenti richiesti, dovrà essere inviata all'indirizzo mail: <a href="mailto:retecertificata@unasca.it" className="text-blue-600 hover:underline">retecertificata@unasca.it</a><br/>
<br/>
Il Comitato di Gestione della Rete Certificata si riserva il diritto di richiedere ulteriori informazioni o documenti
integrativi qualora necessari per la valutazione dell'ammissione. 
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">1.7 Versamento dei diritti di Certificazione</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
Per l'ottenimento ed il mantenimento della Certificazione di cui al punto 12 l'agenzia aderente alla Rete
Certificata dovrà versare i diritti di Certificazione stabiliti e comunicati dal Comitato di gestione. Il versamento
per la Certificazione è annuale.            </p>
          </div>
        </div>
      )
    },
    {
      id: '2',
      title: '2. Privacy e Cybersecurity',
      icon: <Lock className="w-5 h-5" />,
      content: (
        <div className="space-y-4">
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">2.1 GDPR e Privacy</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
Ogni SdC deve nominare un Responsabile della Protezione dei Dati (DPO) per garantire la conformità alle
normative sulla privacy. È necessario condurre valutazioni sui rischi per la privacy e ottenere il consenso degli
utenti per la gestione dei loro dati. Gli utenti devono poter esercitare i loro diritti previsti dal GDPR, e i dati
devono essere protetti da accessi non autorizzati o perdite.            </p>
          </div>
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">2.2 Cybersecurity</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
È essenziale monitorare e proteggere le infrastrutture IT e formare il personale sui rischi di sicurezza
informatica. Devono essere condotti test regolari per valutare vulnerabilità e garantire backup continui per
proteggere le operazioni.            </p>
          </div>
        </div>
      )
    },
    {
      id: '3',
      title: '3. Requisiti tecnologici',
      icon: <Laptop className="w-5 h-5" />,
      content: (
        <div className="space-y-4">
          <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">3.1 Infrastruttura IT</h4>
          <p className="text-gray-700 dark:text-gray-300 text-sm">
          Le agenzie devono disporre di hardware aggiornato e di una connessione internet veloce e stabile.<br />
          <br />
                    <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">3.2 Software e sistemi IT</h4>
  
            Il software utilizzato per le pratiche deve essere compatibile con la Rete Certificata e protetto da misure di
sicurezza come firewall e antivirus.<br /><br />
          <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">3.3 Piattaforma digitale</h4>
            Le agenzie devono essere in grado di utilizzare la piattaforma della Rete per gestire le pratiche e collaborare
con altre agenzie. Devono anche rispettare i protocolli di sicurezza della piattaforma.<br /><br />
                      <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">3.4 Formazione Tecnologica</h4>

È necessaria la partecipazione a corsi di formazione sull'uso della piattaforma e sugli aggiornamenti
tecnologici.
          </p>
        </div>
      )
    },
    {
      id: '4',
      title: '4. Collaborazione e interazione',
      icon: <Users className="w-5 h-5" />,
      content: (
        <div className="space-y-4">
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">4.1 Obbligatorietà della collaborazione</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
All'interno della rete certificata UNASCA, la collaborazione tra i soggetti partecipanti è fondamentale e
obbligatoria. Questo principio è alla base della nostra filosofia e garantisce un funzionamento armonioso ed
efficiente della rete. Tutte le agenzie certificate devono impegnarsi attivamente nella cooperazione reciproca
per garantire la qualità e l'efficacia dei servizi offerti.            </p>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Svincolo degli atti:</strong> Una delle aree principali di collaborazione riguarda lo svincolo degli atti. Le agenzie
all'interno della rete sono tenute a lavorare insieme per facilitare questo processo, assicurando che tutti i
documenti necessari siano gestiti e trasferiti in modo rapido ed efficiente. La condivisione delle risorse e delle
informazioni tra le agenzie permetterà di ridurre i tempi di elaborazione e di migliorare la precisione e
l'affidabilità dei servizi offerti ai clienti.</li>
              <li><strong>Acquisto e scambio di crediti PagoPA:</strong> Un altro aspetto cruciale della collaborazione riguarda l'acquisto e lo
scambio di crediti PagoPA. Le agenzie della rete devono coordinarsi per ottimizzare l'uso di questi crediti,
assicurando che le transazioni avvengano in modo fluido e senza intoppi. La condivisione delle risorse
finanziarie e la cooperazione nel processo di pagamento contribuiranno a migliorare la gestione economica
della rete e a offrire servizi di pagamento più efficienti e convenienti ai clienti.</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">4.2 Condivisione di risorse e competenze</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
La collaborazione tra le agenzie della rete non si limita solo agli aspetti amministrativi e finanziari. È essenziale
che le agenzie condividano risorse e competenze per migliorare continuamente la qualità dei servizi offerti.
Scambio di Best Practices: Potrà essere richiesto di condividere le migliori pratiche operative e gestionali per
ottimizzare i processi interni e migliorare l'efficienza operativa.            </p>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">4.3 Accordi e convenzioni UNASCA</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              All'interno della Rete Certificata UNASCA, l'Associazione potrà sottoscrivere accordi, convenzioni e partnership con soggetti pubblici e privati, finalizzati al miglioramento dei servizi offerti agli utenti, all'innovazione del settore e alla valorizzazione della Categoria.
            </p>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              Tali accordi potranno riguardare, a titolo esemplificativo e non esaustivo:
            </p>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm mb-2">
              <li>servizi tecnologici e piattaforme operative;</li>
              <li>condizioni economiche agevolate per prodotti o servizi;</li>
              <li>convenzioni con enti pubblici, istituzioni o operatori del mercato;</li>
              <li>strumenti di semplificazione operativa o gestionale per gli Studi aderenti.</li>
            </ul>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              Gli accordi sottoscritti da UNASCA, una volta approvati dagli organi competenti e comunicati agli aderenti, diventano parte integrante del sistema della Rete Certificata.
            </p>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              L'adesione alla Rete Certificata UNASCA comporta:
            </p>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm mb-2">
              <li>l'accettazione preventiva delle condizioni contrattuali definite da UNASCA nell'ambito degli accordi e delle convenzioni;</li>
              <li>l'impegno, da parte degli aderenti, a sottoscrivere e rispettare tali accordi, qualora siano resi operativi per la Rete;</li>
              <li>il rispetto delle modalità operative e delle eventuali condizioni economiche previste.</li>
            </ul>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              Resta ferma la possibilità, per il Comitato di Gestione, di prevedere modalità di adesione differenziate o gradualità applicative, in relazione alla natura dell'accordo e alle specificità territoriali o operative degli aderenti.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">4.4 Scambio voucher e collaborazione territoriale</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              Lo scambio di voucher e crediti operativi tra gli aderenti alla Rete Certificata UNASCA rappresenta un principio di collaborazione reciproca e un dovere morale finalizzato al corretto funzionamento della rete e all'ottimizzazione delle risorse disponibili.
            </p>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              Tale principio si applica nel rispetto dei seguenti criteri:
            </p>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm mb-2">
              <li><strong>Ambito di applicazione:</strong> Lo scambio riguarda esclusivamente i voucher e i crediti che lo Studio aderente utilizza effettivamente nell'ambito della propria attività operativa.</li>
              <li><strong>Coerenza territoriale:</strong> Lo scambio deve tenere conto delle specificità del territorio di appartenenza, con particolare riferimento alle Regioni a Statuto Speciale o ai contesti in cui sono previste modalità di pagamento differenziate (es. sistemi regionali integrati con PagoPA).</li>
              <li><strong>Finalità collaborativa:</strong> Lo scambio non ha natura speculativa, ma è finalizzato a garantire continuità operativa, efficienza nei servizi e supporto reciproco tra gli Studi aderenti.</li>
              <li><strong>Equilibrio e reciprocità:</strong> Gli aderenti sono tenuti a mantenere comportamenti improntati a correttezza, equilibrio e reciprocità nello scambio, evitando accumuli o pratiche che possano compromettere l'equità della rete.</li>
            </ul>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              Il Comitato di Gestione potrà definire linee guida operative, strumenti di monitoraggio e eventuali regole di dettaglio per disciplinare lo scambio dei voucher e garantire il corretto funzionamento del sistema.
            </p>
          </div>
        </div>
      )
    },
    {
      id: '5',
      title: '5. Materie di certificazione e percorsi formativi',
      icon: <BookOpen className="w-5 h-5" />,
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">5.1 Autentica di firma</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Corso di base:</strong> Normative e procedure per l'autentica di firma.</li>
              <li><strong>Modulo avanzato:</strong> Gestione dei documenti e sicurezza delle informazioni.</li>
              <li><strong>Esame finale:</strong> Test di valutazione.</li>
              <li><strong>Esenzioni:</strong> L'accesso diretto alla certificazione può essere esentato per chi possiede una laurea in giurisprudenza, scienze delle pubbliche amministrazioni e delle organizzazioni complesse, consulente dei trasporti o economia, oppure ha completato corsi riconosciuti dal Centro Studi "Cesare Ferrari".</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">5.2 Immatricolazioni e passaggi di proprietà</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Corso di base:</strong> Normative sulle immatricolazioni e passaggi di proprietà.</li>
              <li><strong>Modulo avanzato:</strong> Procedure operative e gestione dei documenti.</li>
              <li><strong>Esame finale:</strong> Test di valutazione.</li>
              <li><strong>Esenzioni:</strong> L'accesso diretto alla certificazione può essere esentato per chi possiede una laurea in giurisprudenza, scienze delle pubbliche amministrazioni e delle organizzazioni complesse, consulente dei trasporti, oppure ha completato corsi riconosciuti dal Centro Studi "Cesare Ferrari".</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">5.3 Consulenza per le macchine agricole</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Corso di base:</strong> Normative specifiche per il settore agricolo.</li>
              <li><strong>Modulo avanzato:</strong> Procedure di consulenza e gestione delle pratiche agricole.</li>
              <li><strong>Esame finale:</strong> Test di valutazione.</li>
              <li><strong>Esenzioni:</strong> L'accesso diretto alla certificazione può essere esentato per chi possiede una laurea in giurisprudenza, scienze delle pubbliche amministrazioni e delle organizzazioni complesse, consulente dei trasporti, oppure ha completato corsi riconosciuti dal Centro Studi "Cesare Ferrari".</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">5.4 Trasporto merci</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Corso di base:</strong> Normative sul trasporto merci.</li>
              <li><strong>Modulo avanzato:</strong> Procedure operative e gestione dei documenti di trasporto.</li>
              <li><strong>Esame finale:</strong> Test di valutazione.</li>
              <li><strong>Esenzioni:</strong> L'accesso diretto alla certificazione può essere esentato per chi possiede una laurea in giurisprudenza, scienze delle pubbliche amministrazioni e delle organizzazioni complesse, consulente dei trasporti, oppure ha completato corsi riconosciuti dal Centro Studi "Cesare Ferrari".</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">5.5 Nazionalizzazioni</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Corso di base:</strong> Normative e procedure per la nazionalizzazione dei veicoli.</li>
              <li><strong>Modulo avanzato:</strong> Gestione dei documenti e sicurezza delle informazioni.</li>
              <li><strong>Esame finale:</strong> Test di valutazione.</li>
              <li><strong>Esenzioni:</strong> Aver completato corsi riconosciuti dal Centro Studi "Cesare Ferrari".</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">5.6 Consulenze tecniche</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Corso di base:</strong> Normative e procedure per consulenze tecniche nel settore automobilistico.</li>
              <li><strong>Modulo avanzato:</strong> Analisi tecnica dei veicoli e gestione delle pratiche.</li>
              <li><strong>Esame finale:</strong> Test di valutazione.</li>
              <li><strong>Esenzioni:</strong> L'accesso diretto alla certificazione può essere esentato per chi possiede una laurea in Ingegneria o diploma tecnico, scienze delle pubbliche amministrazioni e delle organizzazioni complesse, consulente dei trasporti, oppure ha completato corsi riconosciuti dal Centro Studi "Cesare Ferrari".</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">5.7 Trasporti eccezionali</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Corso di base:</strong> Normative sui trasporti eccezionali.</li>
              <li><strong>Modulo avanzato:</strong> Procedure operative e gestione dei documenti per trasporti eccezionali.</li>
              <li><strong>Esame finale:</strong> Test di valutazione.</li>
              <li><strong>Esenzioni:</strong> L'accesso diretto alla certificazione può essere esentato per chi ha completato corsi riconosciuti dal Centro Studi "Cesare Ferrari".</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">5.8 Servizi nautici</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Corso di base:</strong> Normative specifiche per i servizi nautici.</li>
              <li><strong>Modulo avanzato:</strong> Procedure operative e gestione delle pratiche nautiche.</li>
              <li><strong>Esame finale:</strong> Test di valutazione.</li>
              <li><strong>Esenzioni:</strong> L'accesso diretto alla certificazione può essere esentato per chi possiede una laurea in giurisprudenza, scienze delle pubbliche amministrazioni e delle organizzazioni complesse, consulente dei trasporti, oppure ha completato corsi riconosciuti dal Centro Studi "Cesare Ferrari".</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">5.9 Trasporto rifiuti</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Corso di base:</strong> Normative sul trasporto rifiuti.</li>
              <li><strong>Modulo avanzato:</strong> Procedure operative e gestione dei documenti di trasporto rifiuti.</li>
              <li><strong>Esame finale:</strong> Test di valutazione.</li>
              <li><strong>Esenzioni:</strong> L'accesso diretto alla certificazione può essere esentato per chi ha completato corsi riconosciuti dal Centro Studi "Cesare Ferrari".</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">5.10 Patenti</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Corso di base:</strong> Normative e procedure per il rinnovo, conversione, riclassificazione e duplicato delle patenti di guida.</li>
              <li><strong>Modulo avanzato:</strong> Procedure operative e gestione delle pratiche di rinnovo, conversione, duplicato e riclassificazione.</li>
              <li><strong>Esame finale:</strong> Test di valutazione.</li>
            </ul>
          </div>

          <div className="mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">5.11 Esenzioni</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              Le esenzioni dalle materie di certificazione possono essere valutate su richiesta dell'aderente alla Rete Certificata UNASCA. Le richieste di esenzione dovranno essere presentate in forma scritta, corredate da documentazione comprovante i requisiti richiesti. Tali richieste saranno esaminate di volta in volta dal Comitato di gestione, che determinerà la possibilità di concedere l'esenzione in base alle qualifiche, all'esperienza o alla formazione pregressa dell'aderente. Il Centro Studi "Cesare Ferrari" potrà esprimere un parere tecnico di supporto al Comitato di gestione.
            </p>
          </div>
        </div>
      )
    },
    {
      id: '6',
      title: '6. Il Rating di professionalità',
      icon: <TrendingUp className="w-5 h-5" />,
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">6.1 Introduzione</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              Il Rating di Professionalità è uno strumento interno al Comitato di gestione della rete (11.2), sviluppato e gestito per valutare e monitorare la qualità delle agenzie aderenti alla rete certificata UNASCA. Questo sistema garantisce che le agenzie mantengano elevati standard di servizio, competenza e affidabilità.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">6.2 Criteri di valutazione</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Feedback dei clienti:</strong> Raccolta e analisi delle opinioni che potranno giungere dei clienti su servizi offerti in qualità di aderente alla Rete Certificata.</li>
              <li><strong>Sondaggi di soddisfazione:</strong> Valutazione dell'esperienza dei clienti con l'agenzia.</li>
              <li><strong>Gestione delle lamentele:</strong> Valutazione della rapidità ed efficacia nella gestione delle lamentele.</li>
              <li><strong>Tempi di espletamento delle pratiche:</strong> Valutazione della rapidità e puntualità nel completamento delle pratiche, tenuto conto delle specificità del territorio di appartenenza.</li>
              <li><strong>Puntualità:</strong> Rispetto dei tempi promessi ai clienti.</li>
              <li><strong>Efficienza operativa:</strong> Capacità di gestire efficacemente il carico di lavoro.</li>
              <li><strong>Formazione continua:</strong> Partecipazione ai corsi di formazione e aggiornamento.</li>
              <li><strong>Frequenza e partecipazione:</strong> Numero di corsi frequentati e completati.</li>
              <li><strong>Qualità della Formazione:</strong> Valutazione dei formatori e risultati nei test post-formazione.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">6.3 Gestione del rating</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              Il "Comitato di gestione" supervisiona l'intero processo di valutazione, dalla raccolta dei dati all'analisi e alla generazione del rating finale. Il rating non è reso pubblico.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">6.4 Comunicazione e azioni correttive</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              <strong>Azioni correttive:</strong> Se un'agenzia riceve un rating insoddisfacente, il Comitato di gestione della Rete avvia un processo di revisione per determinare le azioni correttive necessarie.
            </p>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Consulenze individuali:</strong> Sessioni di consulenza con esperti.</li>
              <li><strong>Formazione aggiuntiva:</strong> Iscrizione a corsi supplementari.</li>
              <li><strong>Monitoraggio intensivo:</strong> Periodo di monitoraggio per assicurare l'implementazione delle azioni correttive.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">6.5 Persistenza nella rete</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              In base ai risultati del rating e alla risposta dell'agenzia alle azioni correttive, il Comitato di gestione decide se l'Agenzia può continuare a far parte della rete certificata.
            </p>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Conferma della permanenza:</strong> Se l'agenzia migliora le proprie performance, può continuare a far parte della rete.</li>
              <li><strong>Sospensione temporanea:</strong> Se necessitano ulteriori miglioramenti, l'agenzia può essere sospesa temporaneamente.</li>
              <li><strong>Esclusione dalla Rete/o servizio:</strong> In casi estremi, l'agenzia può essere esclusa definitivamente dalla rete certificata UNASCA o dal singolo servizio certificato.</li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: '7',
      title: '7. Modalità di certificazione',
      icon: <Award className="w-5 h-5" />,
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">7.1 Valutazione delle competenze</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Percorso formativo:</strong> Completamento del percorso formativo specifico.</li>
              <li><strong>Audit periodico:</strong> Audit periodici per valutare l'adeguamento agli standard di qualità.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">7.2 Processo di certificazione</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Domanda di certificazione:</strong> Presentazione della domanda al Comitato di gestione della Rete.</li>
              <li><strong>Pre-requisiti:</strong> Lo SdC dovrà dimostrare di essere in possesso dei pre-requisiti richiesti.</li>
              <li><strong>Percorso formativo:</strong> In relazione alla materia scelta per la certificazione si dovrà effettuare il percorso formativo specifico.</li>
              <li><strong>Esame di certificazione:</strong> Superamento di un esame teorico e/o pratico.</li>
              <li><strong>Rilascio della certificazione:</strong> Emissione del certificato.</li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: '8',
      title: '8. Mantenimento della certificazione',
      icon: <Award className="w-5 h-5" />,
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">8.1 Formazione continua</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Corsi di aggiornamento annuali:</strong> Partecipazione a corsi di aggiornamento sul tema della certificazione ottenuta.</li>
              <li><strong>Nuove certificazioni:</strong> Possibilità di ottenere nuove certificazioni in altre aree specifiche.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">8.2 Rinnovo della certificazione</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Revisione periodica:</strong> Revisione periodica delle competenze e dei servizi offerti.</li>
              <li><strong>Esame di aggiornamento:</strong> Superamento di un esame di aggiornamento ogni due anni.</li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: '9',
      title: '9. Procedure di espulsione',
      icon: <AlertCircle className="w-5 h-5" />,
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">9.1 Motivi di Espulsione</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Violazione delle normative:</strong> Violazione delle normative vigenti.</li>
              <li><strong>Non conformità agli standard:</strong> Mancanza di conformità agli standard di qualità.</li>
              <li><strong>Comportamenti non etici:</strong> Comportamenti non etici o non professionali.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">9.2 Processo di espulsione</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Notifica di violazione:</strong> Comunicazione scritta delle violazioni rilevate.</li>
              <li><strong>Risposta e correzione:</strong> Opportunità per l'agenzia di rispondere e correggere le violazioni.</li>
              <li><strong>Decisione finale:</strong> In caso di mancata correzione, espulsione definitiva dalla rete certificata. Le decisioni spettano al Comitato di gestione. La decisione finale viene comunicata tempestivamente al Poligrafico Zecca dello Stato per l'annullamento o modifica del Certificato di cui al punto 12.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">9.3 Ricorso</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Presentazione del ricorso:</strong> In caso di espulsione, lo SdC ha il diritto di presentare ricorso.</li>
              <li><strong>Probiviri dell'UNASCA:</strong> Il ricorso dovrà essere rivolto ai probiviri dell'UNASCA, i quali esamineranno il caso e forniranno una decisione finale.</li>
              <li><strong>Decisione definitiva:</strong> La decisione dei probiviri dell'UNASCA sarà definitiva e vincolante.</li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: '10',
      title: '10. Regole di comportamento e Codice Etico',
      icon: <Scale className="w-5 h-5" />,
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">10.1 Integrità e trasparenza</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Onestà:</strong> Operare con onestà e trasparenza.</li>
              <li><strong>Conformità:</strong> Rispettare le normative e gli standard di qualità.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">10.2 Professionalità</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Competenza:</strong> Mantenere un elevato livello di competenza.</li>
              <li><strong>Formazione:</strong> Partecipare ai programmi di formazione e aggiornamento.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">10.3 Rispetto e collaborazione</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Ambiente di rispetto:</strong> Promuovere un ambiente di rispetto e collaborazione.</li>
              <li><strong>Condivisione delle conoscenze:</strong> Condividere conoscenze ed esperienze. In caso di reiterate violazioni, il Comitato di gestione potrà prevedere sanzioni disciplinari proporzionate alla gravità dell'episodio.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">10.4 Confidenzialità</h4>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Protezione delle informazioni:</strong> Proteggere le informazioni sensibili e rispettare la privacy dei clienti.</li>
              <li><strong>Sicurezza dei dati:</strong> Garantire la sicurezza dei dati gestiti.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">10.5 Piattaforme digitali</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              Gli Studi aderenti alla Rete Certificata UNASCA non possono aderire a piattaforme digitali che impongano un prezzo finale fisso o predeterminato al cittadino per l'espletamento di pratiche automobilistiche.
            </p>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              Inoltre, è fatto divieto di aderire a piattaforme digitali che promuovano direttamente l'espletamento della pratica automobilistica, presentandosi come soggetti intermedi o alternativi agli Studi di Consulenza.
            </p>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              Tali modelli sono ritenuti incompatibili con i valori di autonomia professionale, qualità del servizio e valorizzazione della Categoria, alla base della Rete Certificata UNASCA.
            </p>
          </div>
        </div>
      )
    },
    {
      id: '11',
      title: '11. Governance della Rete',
      icon: <Users className="w-5 h-5" />,
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">11.1 Comitato di gestione</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              Il Comitato di gestione rappresenta l'organo decisionale centrale della Rete Certificata UNASCA, con il compito di garantire il rispetto degli standard qualitativi, la trasparenza e l'efficienza operativa degli Studi di Consulenza aderenti. La sua funzione principale è quella di supervisionare, regolamentare e promuovere la crescita e l'innovazione della rete, attraverso l'adozione di politiche strategiche e la gestione delle certificazioni.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">11.2 Struttura organizzativa</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              Il Comitato di gestione è composto da un Presidente nominato dal Segretario Nazionale Studi, da due rappresentanti nominati dalla Segreteria Nazionale Studi UNASCA e da un rappresentante nominato dal Centro Studi "Cesare Ferrari" (appartenente al settore Studi) che svolgerà un ruolo di supporto scientifico nell'individuazione delle materie oggetto di formazione.
            </p>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              Il Comitato può altresì avvalersi della presenza di un massimo di due componenti esterni di profilo istituzionale, individuati tra personalità di comprovata esperienza e riconosciuto prestigio nei rapporti con le istituzioni e nei settori di riferimento. Tali componenti svolgono funzioni di indirizzo strategico e rappresentanza, senza diritto di voto e senza partecipazione ai processi decisionali, contribuendo allo sviluppo delle relazioni istituzionali, al dialogo con gli stakeholder pubblici e privati e alla valorizzazione della Rete Certificata UNASCA nei contesti nazionali di riferimento, contribuendo inoltre all'individuazione di eventuali nuovi percorsi formativi.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">11.3 Compiti del Comitato di gestione</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              Il Comitato di gestione della Rete Certificata UNASCA ha il compito di garantire un'efficace gestione e supervisione della rete certificata.
            </p>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Formazione:</strong> definizione dei programmi formativi necessari all'ottenimento della Certificazione.</li>
              <li><strong>Certificazione:</strong> individua le Agenzie che soddisfano i requisiti per ottenere il Certificato di garanzia di cui al punto 12 e predispone idonea comunicazione al Poligrafico e Zecca dello Stato. Inoltre, si occupa di segnalare eventuali modifiche alle certificazioni rilasciate, garantendo un aggiornamento costante del sistema. Stabilisce la quota annuale per il mantenimento della Certificazione.</li>
              <li><strong>Qualità e controllo:</strong> Supervisiona la conformità agli standard di qualità e attua misure di monitoraggio per garantire il rispetto delle normative e delle procedure della rete.</li>
              <li><strong>Etica e compliance:</strong> Vigila sul rispetto del Codice Etico UNASCA e gestisce eventuali segnalazioni di non conformità o violazioni delle linee guida etiche.</li>
              <li><strong>Innovazione e sviluppo:</strong> individuare nuove opportunità di crescita, miglioramenti tecnologici e strategie di sviluppo per la rete certificata.</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">11.4 Gratuità delle cariche</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              Tutte le cariche del Comitato di gestione della Rete che fanno parte di Unasca sono gratuite.
            </p>
          </div>
        </div>
      )
    },
    {
      id: '12',
      title: '12. Certificazione di garanzia',
      icon: <Shield className="w-5 h-5" />,
      content: (
        <div className="space-y-4">
          <p className="text-gray-700 dark:text-gray-300 text-sm">
            La "Certificazione di garanzia" è un attestato che certifica la qualità del servizio offerto dalle Agenzie aderenti alla Rete Certificata UNASCA.
          </p>
          <p className="text-gray-700 dark:text-gray-300 text-sm">
            Questa certificazione viene rilasciata in doppio formato previo versamento dei diritti di Certificazione:
          </p>
          <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
            <li><strong>Cartaceo</strong> su pergamena ufficiale, con elementi di sicurezza per garantirne l'autenticità.</li>
            <li><strong>Digitale</strong>, accessibile tramite QR Code presente sulla certificazione, che rimanda alla piattaforma ufficiale della Rete Certificata, con la possibilità di verifica in tempo reale.</li>
          </ul>
          <p className="text-gray-700 dark:text-gray-300 text-sm">
            Il contrassegno è realizzato utilizzando le tecnologie adottate dal Poligrafico e Zecca dello Stato, con elementi di anticontraffazione e identificazione univoca.
          </p>
          <p className="text-gray-700 dark:text-gray-300 text-sm">
            La certificazione attesta il rispetto degli standard qualitativi e professionali previsti dal regolamento, garantendo ai cittadini la sicurezza di rivolgersi a uno Studio di Consulenza Certificato.
          </p>
          <p className="text-gray-700 dark:text-gray-300 text-sm">
            L'emissione e il rinnovo della Certificazione di garanzia avviene su autorizzazione del Comitato di gestione, previo mantenimento dei requisiti richiesti.
          </p>
          <p className="text-gray-700 dark:text-gray-300 text-sm italic">
            Allegato al presente regolamento vi è un FAC-SIMILE del Certificato di garanzia con indicazione degli elementi anticontraffazione.
          </p>
        </div>
      )
    },
    {
      id: '13',
      title: '13. Vantaggi della Rete Certificata',
      icon: <Award className="w-5 h-5" />,
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">13.1 Garanzia sulla conclusione e buon esito delle pratiche</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              UNASCA sarà garante e darà GARANZIA nei confronti dei clienti/utenti che si rivolgono alla Rete certificata sulla conclusione e sul buon esito delle pratiche gestite dagli studi aderenti alla rete. Questa garanzia è volta a rafforzare l'affidabilità e la fiducia nel servizio offerto dalle agenzie certificate.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">13.2 Visibilità della Rete</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              <strong>Portale di visibilità:</strong> La visibilità degli SdC certificati all'interno della rete sarà garantita tramite il sito <a href="http://www.unasca.it" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">www.unasca.it</a>. I clienti potranno utilizzare questo portale per individuare l'agenzia certificata di loro gradimento, consultando informazioni dettagliate sui servizi offerti e sulle certificazioni ottenute da ciascuna agenzia.
            </p>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              <strong>Altre forme di pubblicità e comunicazione:</strong> La rete certificata UNASCA utilizzerà anche altre forme di pubblicità e comunicazione per aumentare la visibilità degli SdC certificati. Queste includono:
            </p>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li><strong>Siti Web:</strong> Oltre al portale www.unasca.it, saranno sviluppati e utilizzati siti web dedicati per promuovere la rete e le singole agenzie.</li>
              <li><strong>Social Media:</strong> Campagne pubblicitarie e di comunicazione saranno attivate sui principali social media (Facebook, Instagram, LinkedIn, ecc.) per raggiungere un pubblico più ampio e diversificato.</li>
              <li><strong>Campagne dedicate:</strong> Saranno progettate e implementate campagne di marketing mirate, che il comitato di gestione approverà di volta in volta. Queste campagne potranno includere promozioni speciali, eventi online e offline, collaborazioni con influencer e altre strategie di marketing digitale.</li>
            </ul>
            <p className="text-gray-700 dark:text-gray-300 text-sm mt-2">
              Queste iniziative saranno coordinate e approvate dal comitato di gestione, assicurando che tutte le attività promozionali siano allineate con gli obiettivi strategici della rete certificata UNASCA e contribuiscano efficacemente alla sua visibilità e crescita.
            </p>
          </div>
        </div>
      )
    },
    {
      id: '14',
      title: '14. Clausole transitorie',
      icon: <Clock className="w-5 h-5" />,
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">14.1 Ingresso nella Rete Certificata (Fase Transitoria)</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              Per facilitare l'avvio della Rete Certificata, è prevista una fase transitoria della durata di due anni, durante la quale l'ingresso alla Rete sarà autorizzato anche con la sola presentazione dei pre-requisiti di cui ai punti 1.1, 1.2 e 1.3.
            </p>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              <strong>Tale fase transitoria terminerà il 31 dicembre 2026.</strong>
            </p>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              Durante questo periodo, gli Studi di Consulenza potranno essere ammessi con Certificazione Provvisoria, pur non avendo ancora completato il percorso di certificazione. L'ammissione definitiva sarà comunque subordinata al completamento del percorso di certificazione previsto.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">14.2 Periodo per la Certificazione Definitiva</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              Le agenzie ammesse in fase transitoria avranno 24 mesi di tempo dalla data di ammissione per completare l'iter formativo, sostenere le valutazioni del Centro Studi "Cesare Ferrari" ed essere sottoposte al monitoraggio richiesto.
            </p>
            <p className="text-gray-700 dark:text-gray-300 text-sm">
              Di conseguenza, l'ultima possibile scadenza per la conclusione del percorso di certificazione, per chi entrasse entro il 31 dicembre 2026, sarà il <strong>31 dicembre 2028</strong>.
            </p>
          </div>

          <div className="p-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg">
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2 text-lg">14.3 Esito della certificazione</h4>
            <p className="text-gray-700 dark:text-gray-300 text-sm mb-2">
              Al termine dei 24 mesi, lo SdC dovrà aver completato con esito positivo l'intero percorso previsto. In caso contrario, il Comitato di Gestione potrà:
            </p>
            <ul className="list-disc list-inside space-y-1 text-gray-700 dark:text-gray-300 text-sm">
              <li>richiedere misure correttive con una proroga massima di ulteriori 6 mesi;</li>
              <li>in caso di esito negativo anche dopo la proroga, escludere l'agenzia dalla Rete Certificata.</li>
            </ul>
          </div>
        </div>
      )
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex justify-center mb-6">
            <Shield className="w-20 h-20 text-blue-600" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Regolamento per l'accesso alla<br />"Rete Certificata UNASCA"
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-8">
            Un contrassegno di Stato a tutela del cittadino
          </p>

          {/* Immagine Rete Certificata */}
          <div className="flex justify-center mb-8">
            <img
              src="/images/rete_certificata.png"
              alt="Rete Certificata UNASCA"
              className="max-w-md w-full h-auto rounded-2xl shadow-lg border-4 border-blue-600 dark:border-blue-500"
            />
          </div>

          {/* Bottone Download PDF */}
          <div className="flex justify-center">
            <a
              href="/pdf/REGOLAMENTO_RETE_CERTIFICATA_REV6.pdf"
              download
              className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-md transition-colors duration-200"
            >
              <Download className="w-5 h-5" />
              Scarica il Regolamento (PDF)
            </a>
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-4">
          {sections.map((section) => (
            <div
              key={section.id}
              className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden"
            >
              <button
                onClick={() => toggleSection(section.id)}
                className="w-full px-6 py-4 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className="text-blue-600">{section.icon}</div>
                  <h2 className="text-lg font-semibold text-gray-900 dark:text-white text-left">
                    {section.title}
                  </h2>
                </div>
                {expandedSections.includes(section.id) ? (
                  <ChevronUp className="w-5 h-5 text-gray-500" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-500" />
                )}
              </button>
              
              {expandedSections.includes(section.id) && (
                <div className="px-6 py-4 border-t border-gray-200 dark:border-gray-700">
                  {section.content}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Download PDF */}
        <div className="mt-8 text-center">
          <p className="text-gray-600 dark:text-gray-400 text-sm">
            Per maggiori informazioni, contattare: <a href="mailto:retecertificata@unasca.it" className="text-blue-600 hover:underline">retecertificata@unasca.it</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegolamentoPage;

